module.exports = __webpack_public_path__ + "img/problem-title.4850ee93.png";